import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { checkIsTodayOrder } from '../../../../../../../../helper/checkIsTodayOrder'
import ButtonsModal from '../../../../../../../Elements/modal/ButtonsModal'
import { setZReportSelectedOrder, setZReportShowAbortOrder, setZReportShowOrder, setZReportShowOrderData, setZReportShowPaymentMethod } from '../../../../../../../../redux/action/zreport'
import { printRequestsThunk } from '../../../../../../../../redux/thunk/order/printRequests'
import { setAppEventZIndex } from '../../../../../../../../redux/action/system'

const EVENT_Z_INDEX = 1

const UnpaidOrderModal = React.memo(() => {
	const { t } = useTranslation()
	const showOrder = useSelector(store => store.zReport.orderModal.showOrder)
	const selectedOrder = useSelector(store => store.zReport.selectedOrder)
	const dispatch = useDispatch()
	const isPaid = selectedOrder?.payments?.filter(item => item?.method === selectedOrder?.paymentMethod)[0]?.payed

	const showOrderDetails = () => {
		dispatch(setZReportShowOrderData(true))
		dispatch(setZReportShowOrder(false))
	}

	const printOrderClick = useCallback(async () => {
		await dispatch(printRequestsThunk(selectedOrder.orderId, 'PRELIMINARY_RECEIPT'))
		dispatch(setZReportShowOrder(false))
	}, [dispatch, selectedOrder?.orderId])

	const handleClose = () => {
		dispatch(setZReportShowOrder(false))
		dispatch(setZReportSelectedOrder(null))
		dispatch(setAppEventZIndex(0))
	}

	const abortOrder = () => {
		dispatch(setZReportShowAbortOrder(true))
		dispatch(setZReportShowOrder(false))
	}

	const handlePayment = () => {
		dispatch(setZReportShowOrder(false))
		dispatch(setZReportShowPaymentMethod(true))
	}

	const isDenied = selectedOrder?.status?.status === 'DENIED'
	const isCanceled = selectedOrder?.status?.status === 'CANCELED'
	const isAborted = selectedOrder?.status?.status === 'ABORTED'
	const isAccepted = selectedOrder?.status?.status !== 'NOT_ACCEPTED'
	const isRegistered = selectedOrder?.status?.status !== 'NOT_REGISTERED'
	const isClosed = !!selectedOrder?.zNumber
	const orderDate = selectedOrder?.preOrder ? selectedOrder?.preOrder : selectedOrder?.orderDate
	const isTodayOrder = checkIsTodayOrder(orderDate)
	const conditionForPrint = !isCanceled && !isDenied && isAccepted && isRegistered && isTodayOrder && !isAborted
	const isRegisteredByCounters = !!selectedOrder?.orderDayCounter

	const buttons = [
		{ icon: 'payment', text: t('order.modal.order_pay'), onClick: handlePayment, show: !isCanceled && !isDenied && !isClosed && isRegistered && isAccepted && !isPaid && !isAborted },
		{ icon: 'show', text: t('order.modal.show_order'), onClick: showOrderDetails, show: true },
		{ icon: 'print', text: t('order.modal.print_order'), onClick: printOrderClick, show: conditionForPrint },
		{ icon: 'abort', text: t('order.modal.abort_order'), onClick: abortOrder, show: !isCanceled && !isDenied && !isClosed && isRegistered && isAccepted && !isPaid && isRegisteredByCounters && !isAborted },
	]

	return (
		<ButtonsModal isOpen={showOrder && selectedOrder}
									close={handleClose}
									id="report-unpaid-order-buttons-modal"
									title={(selectedOrder?.orderDayCounter ?
										t('order.modal.number_order') + ' #' + selectedOrder?.orderDayCounter
										: t('order.modal.without_number'))}
									zIndex={EVENT_Z_INDEX}
									returnZIndex={0}
									size="small"
									buttons={buttons} />
	)
})

UnpaidOrderModal.displayName = 'UnpaidOrderModal'
export default UnpaidOrderModal
